function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import createLocationMiddleware from 'farce/createLocationMiddleware';
import invariant from 'invariant';
export default function createMatcherNamedRoutesMiddleware(matcher) {
  var paths = {};

  function makePaths(route, basePath) {
    var children = route.children,
        path = route.path,
        name = route.name;
    var fullPath = matcher.joinPaths(basePath, path);

    if (name) {
      !(name[0] !== '/') ? process.env.NODE_ENV !== "production" ? invariant(false, 'route name invalid: %s. A name cannot start with /', name) : invariant(false) : void 0;
      paths[name] = fullPath;
    }

    if (children) {
      if (!Array.isArray(children)) {
        // flatten route routes
        Object.values(children).forEach(function (groupChildren) {
          groupChildren.forEach(function (childRoute) {
            return makePaths(childRoute, fullPath);
          });
        });
      } else {
        children.forEach(function (childRoute) {
          return makePaths(childRoute, fullPath);
        });
      }
    }
  }

  function resolveLocation(location) {
    var name = location.name;
    var pathname = location.pathname,
        params = location.params;

    if (!name && // Assume that anything that looks like an absolute path isn't a route
    // name.
    pathname.charAt(0) !== '/' && // Assume that anything that looks like an absolute URL isn't a route
    // name either.
    pathname.indexOf('://') === -1) {
      name = pathname;
    }

    if (!name) {
      return location;
    }

    var path = paths[name];
    !path ? process.env.NODE_ENV !== "production" ? invariant(false, 'Unknown route: %s', name) : invariant(false) : void 0;
    return _extends({}, location, {
      pathname: matcher.format(path, params)
    });
  }

  matcher.routeConfig.forEach(function (route) {
    return makePaths(route, '/');
  });
  return createLocationMiddleware({
    makeLocationDescriptor: resolveLocation,
    makeLocation: function makeLocation(location) {
      return location;
    }
  });
}